module.exports = __webpack_public_path__ + "img/teacher-svg.0fd3c45f.svg";